import MusicSyncList from "../components/MusicSyncList";

const ListMusicSyncPage = () => {
  return (
    <MusicSyncList />
  );
};

export default ListMusicSyncPage;
